import { getCanCreateSmartModules } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getIsConvertibleToAutomated, getCanUsePlaintext
// @ts-expect-error Could not find a declaration file for module ...
} from 'EmailEditorUI/redux/selectors/EmailSelectors';
// @ts-expect-error Could not find a declaration file for module ...
import { getCanCreateAbTest } from 'EmailEditorUI/redux/selectors/EmailSelectors';
// @ts-expect-error Could not find a declaration file for module ...
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
export const MAYBE_LATER_SHOW_AGAIN_ONBOARDING = 86400000; // 1 day in ms

export const ONBOARDING_IDS = {
  SINGLE: 'SINGLE',
  CUSTOM: 'CUSTOM',
  CUSTOM_LEARN_MORE: 'CUSTOM_LEARN_MORE',
  CONTEXTUAL_AUTOMATION: 'CONTEXTUAL_AUTOMATION'
};
export const MAX_ONBOARDING_STEPS = {
  [ONBOARDING_IDS.CONTEXTUAL_AUTOMATION]: 5
};
export const ONBOARDING_STEP_NAMES = {
  // Merged
  MODULES: 'MODULES',
  SMART_RULES: 'SMART_RULES',
  SAVE_AND_REVISIONS: 'SAVE_AND_REVISIONS',
  EDIT_EMAIL_TEMPLATE: 'EDIT_EMAIL_TEMPLATE',
  SENDING_OPTIONS: 'SENDING_OPTIONS',
  EMAIL_ACTIONS: 'EMAIL_ACTIONS',
  SEND_TEST_EMAIL: 'SEND_TEST_EMAIL',
  FINAL_REVIEW: 'FINAL_REVIEW',
  PLAIN_TEXT: 'PLAIN_TEXT',
  PLAIN_TEXT_TOGGLE: 'PLAIN_TEXT_TOGGLE',
  PREVIEW: 'PREVIEW',
  AUTOMATED_EMAIL: 'AUTOMATED_EMAIL',
  LEARN_MORE: 'LEARN_MORE',
  SAVE_TEMPLATE: 'SAVE_TEMPLATE',
  // updated ab test pattern
  UPDATED_CREATE_AB_TEST: 'UPDATED_CREATE_AB_TEST',
  // contextual automation
  CREATE_WORKFLOW: 'CREATE_WORKFLOW',
  WORKFLOW_TRIGGER: 'WORKFLOW_TRIGGER',
  WORKFLOW_ACTION: 'WORKFLOW_ACTION',
  TURN_WORKFLOW_ON: 'TURN_WORKFLOW_ON',
  // AI Dynamic Text
  AI_DYNAMIC_TEXT: 'AI_DYNAMIC_TEXT'
};
// These are references to selectors to filter and REMOVE steps from the ONBOARDINGS when they return false
export const ONBOARDING_STEP_CRITERIA = {
  [ONBOARDING_STEP_NAMES.SMART_RULES]: getCanCreateSmartModules,
  [ONBOARDING_STEP_NAMES.SAVE_AND_REVISIONS]: state => !getIsReadOnlyMode(state),
  [ONBOARDING_STEP_NAMES.AUTOMATED_EMAIL]: getIsConvertibleToAutomated,
  [ONBOARDING_STEP_NAMES.PLAIN_TEXT]: getCanUsePlaintext,
  [ONBOARDING_STEP_NAMES.PLAIN_TEXT_TOGGLE]: getCanUsePlaintext,
  [ONBOARDING_STEP_NAMES.UPDATED_CREATE_AB_TEST]: getCanCreateAbTest
};
export const LEARN_MORE_STEPS = [ONBOARDING_STEP_NAMES.MODULES, ONBOARDING_STEP_NAMES.SMART_RULES, ONBOARDING_STEP_NAMES.SAVE_AND_REVISIONS, ONBOARDING_STEP_NAMES.PLAIN_TEXT, ONBOARDING_STEP_NAMES.PLAIN_TEXT_TOGGLE, ONBOARDING_STEP_NAMES.EDIT_EMAIL_TEMPLATE, ONBOARDING_STEP_NAMES.UPDATED_CREATE_AB_TEST, ONBOARDING_STEP_NAMES.PREVIEW, ONBOARDING_STEP_NAMES.AUTOMATED_EMAIL];

// Dictates order of steps.
export const ONBOARDING_STEPS = {
  // SINGLE onboarding is a special onboarding allowing to only open one step per time
  [ONBOARDING_IDS.SINGLE]: [ONBOARDING_STEP_NAMES.PLAIN_TEXT_TOGGLE, ONBOARDING_STEP_NAMES.LEARN_MORE, ONBOARDING_STEP_NAMES.AI_DYNAMIC_TEXT, ...LEARN_MORE_STEPS],
  [ONBOARDING_IDS.CUSTOM_LEARN_MORE]: [ONBOARDING_STEP_NAMES.MODULES, ONBOARDING_STEP_NAMES.SMART_RULES, ONBOARDING_STEP_NAMES.SAVE_AND_REVISIONS, ONBOARDING_STEP_NAMES.PLAIN_TEXT, ONBOARDING_STEP_NAMES.PLAIN_TEXT_TOGGLE, ONBOARDING_STEP_NAMES.EDIT_EMAIL_TEMPLATE, ONBOARDING_STEP_NAMES.UPDATED_CREATE_AB_TEST, ONBOARDING_STEP_NAMES.PREVIEW, ONBOARDING_STEP_NAMES.AUTOMATED_EMAIL],
  [ONBOARDING_IDS.CUSTOM]: [ONBOARDING_STEP_NAMES.MODULES, ONBOARDING_STEP_NAMES.SMART_RULES, ONBOARDING_STEP_NAMES.SAVE_AND_REVISIONS, ONBOARDING_STEP_NAMES.EDIT_EMAIL_TEMPLATE, ONBOARDING_STEP_NAMES.UPDATED_CREATE_AB_TEST, ONBOARDING_STEP_NAMES.SENDING_OPTIONS, ONBOARDING_STEP_NAMES.PREVIEW, ONBOARDING_STEP_NAMES.FINAL_REVIEW],
  [ONBOARDING_IDS.CONTEXTUAL_AUTOMATION]: [ONBOARDING_STEP_NAMES.CREATE_WORKFLOW, ONBOARDING_STEP_NAMES.WORKFLOW_TRIGGER, ONBOARDING_STEP_NAMES.WORKFLOW_ACTION, ONBOARDING_STEP_NAMES.TURN_WORKFLOW_ON]
};